import "./welcomeWizard.scss";

import PropTypes from "prop-types";
import React from "react";

import keyConstants from "../../constants/keyConstants";
import Icon from "../interface/Icon";

const onKeyDown = (e, onEnter) => {
  let keyHandled = false;
  if (e.key === keyConstants.Enter && onEnter) {
    onEnter();
    keyHandled = true;
  }
  if (keyHandled) {
    e.stopPropagation();
    e.preventDefault();
  }
};

const WelcomeWizardTypeButton = props => {
  return (
    <div
      className={`welcomeWizardTypeButton ${props.disabled ? "disabled" : ""}`}
      onClick={props.disabled ? null : props.onClick}
      tabIndex={props.disabled ? -1 : props.tabIndex ? props.tabIndex : 0}
      onKeyDown={e => onKeyDown(e, props.disabled ? null : props.onClick)}
    >
      <Icon icon={props.icon} color={props.iconColor} />
      <div className="welcomeWizardTypeButtonLabel">{props.label}</div>
    </div>
  );
};

WelcomeWizardTypeButton.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  iconColor: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  tabIndex: PropTypes.number
};

export default WelcomeWizardTypeButton;
